module.exports = __webpack_public_path__ + "img/1509408890.9f32de81.jpg";